// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ProfilerController = function ($scope, Profiler, ProfilerSettings) {
    $scope.profiles = Profiler.query();
    $scope.settings = ProfilerSettings.get();
    $scope.updateSettings = function () {
        $scope.settings.$update();
    };
};
ProfilerController.$inject = ['$scope', 'Profiler', 'ProfilerSettings'];
